import React from 'react';
import './FooterComponent.css'
import { Grid } from '@mui/material';

const FooterComponent = () => {
	const gridItemSizeXs = 12;

	return(
		<Grid container className="footer-background m-t-auto">
			<Grid item xs={ gridItemSizeXs } className='dis-flex justify-center'>
				<img src="./BfB_logo_white_powered_by.png" alt="BfB Logo" className="logo" />
			</Grid>
			<Grid item xs={ gridItemSizeXs }>
				<div className="information">
					<a className='text-white' rel="noopener noreferrer" target="_blank" href="https://www.bfb-labs.com/lumi-nova-privacy-policy ">Privacy Notice</a>
					&nbsp;|&nbsp;
					<a className='text-white' rel="noopener noreferrer" target="_blank" href="https://bfb-labs.com">BfB Labs © { new Date().getFullYear() }</a>
				</div>
			</Grid>
		</Grid>
	)
}

export default FooterComponent;